/**
 * The web address of a typed value, or null when it is not one (design d2). A missing `https://` is
 * added by itself when the rest is an address ("laziibee.com/tickets").
 */
export function normalizeAddress(value: string): string | null {
  const trimmed = value.trim();
  if (trimmed === '' || /\s/.test(trimmed)) {
    return null;
  }
  const withScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const parsed = new window.URL(withScheme);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return null;
    }
    // A host with no dot ("laziibee") is not a public address.
    if (!parsed.hostname.includes('.') || parsed.hostname.endsWith('.')) {
      return null;
    }
    return withScheme;
  } catch {
    return null;
  }
}
